<template>
  <div class="omnistock omni-card-footer" role="footer">
    <slot />
  </div>
</template>

<style lang="scss">
.omnistock {
    &.omni-card-footer {
        padding: 1rem;
        margin-top: auto;
    }
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "OmniCardFooter",
});
</script>
